(function () {
  'use strict';

  if (window.UKLedLightsSwitchboardTooltip && typeof window.UKLedLightsSwitchboardTooltip.init === 'function') {
    window.UKLedLightsSwitchboardTooltip.init(document);
    return;
  }

  var popover = null;
  var current = null;
  var hideTimer = null;

  function ensurePopover() {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.className = 'ukl-switchboard-icon-tip';
    popover.id = 'ukl-switchboard-icon-tooltip';
    popover.setAttribute('role', 'tooltip');
    popover.setAttribute('aria-hidden', 'true');
    document.body.appendChild(popover);
    return popover;
  }

  function hide() {
    window.clearTimeout(hideTimer);
    if (popover) {
      popover.classList.remove('is-visible');
      popover.setAttribute('aria-hidden', 'true');
    }
    if (current) current.removeAttribute('aria-describedby');
    current = null;
  }

  function show(trigger, text) {
    var tip = ensurePopover();
    window.clearTimeout(hideTimer);
    if (current && current !== trigger) current.removeAttribute('aria-describedby');
    tip.textContent = text;
    tip.classList.add('is-visible');
    tip.setAttribute('aria-hidden', 'false');
    var triggerRect = trigger.getBoundingClientRect();
    var tipRect = tip.getBoundingClientRect();
    var left = triggerRect.left + triggerRect.width / 2 - tipRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tipRect.width - 8));
    var top = triggerRect.top - tipRect.height - 10;
    if (top < 8) top = triggerRect.bottom + 10;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    current = trigger;
    trigger.setAttribute('aria-describedby', tip.id);
    hideTimer = window.setTimeout(hide, 4500);
  }

  function bindIcon(icon) {
    var item = icon.closest('.ukl-switchboard-feature') || icon;
    var text = icon.getAttribute('data-ukl-icon-tip');
    if (!text || item.dataset.uklTooltipBound) return;
    item.dataset.uklTooltipBound = 'true';
    item.classList.add('has-icon-tip');

    var trigger = document.createElement('button');
    trigger.className = 'ukl-switchboard-feature-trigger';
    trigger.type = 'button';
    trigger.setAttribute('aria-label', item.dataset.uklTooltipLabel || '');

    while (item.firstChild) trigger.appendChild(item.firstChild);
    item.appendChild(trigger);

    function activate(event) {
      event.preventDefault();
      event.stopPropagation();
      if (current === trigger) {
        hide();
        return;
      }
      show(trigger, text);
    }

    trigger.addEventListener('click', activate);
  }

  function init(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('.ukl-switchboard-feature-icon[data-ukl-icon-tip]').forEach(bindIcon);
  }

  window.UKLedLightsSwitchboardTooltip = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function () { if (current) hide(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && current) hide(); });
  window.addEventListener('scroll', function () { if (current) hide(); }, { passive: true });
  window.addEventListener('resize', function () { if (current) hide(); });
})();
